import React from 'react';
import { Main } from './components';

const Picking: React.FC = () => {
    return <Main />;
};

export default Picking;
